import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { BlobService } from '../../../services/blob/blob.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.css']
})

export class ImageComponent implements OnInit, OnChanges {

    @Input() public srcPath: string | undefined = undefined;
    @Input() public className: string | undefined = undefined;
    @Input() public isApiImage: string | undefined = undefined;

    public constructor(public appService: AppService, public blobService: BlobService) { }

    public ngOnInit(): void {

        if (this.srcPath) {

            if (this.isApiImage && (this.isApiImage == "1" || this.isApiImage.toLowerCase() == "true")) {

                this.blobService.getBlobBase64String(this.srcPath).subscribe((r: any | null) => {

                    if (r != null) {

                        if (r == "data:text/xml;base64," || r instanceof HttpErrorResponse) { // no image data or error 

                            this.srcPath = this.appService.defaultImageUri;

                        } else {

                            this.srcPath = r;
                        }
                    }
                });
            }
        } else if (this.srcPath == "") {

            this.srcPath = this.appService.defaultImageUri;
        }
    }

    public ngOnChanges(changes: SimpleChanges) {

        if (changes['srcPath']) {

            console.log('srcPath changed from', changes['srcPath'].previousValue, 'to', changes['srcPath'].currentValue);

            if (this.srcPath) {

                if (this.isApiImage && (this.isApiImage == "1" || this.isApiImage.toLowerCase() == "true")) {

                    this.blobService.getBlobBase64String(this.srcPath).subscribe((r: any | null) => {

                        if (r != null) {

                            if (r == "data:text/xml;base64," || r instanceof HttpErrorResponse) { // no image data or error 

                                this.srcPath = this.appService.defaultImageUri;

                            } else {

                                this.srcPath = r;
                            }
                        }
                    });
                }
            }
        }
    }
}
